import { render } from "./ProductLifeCycle.vue?vue&type=template&id=97901dfe&scoped=true"
import script from "./ProductLifeCycle.vue?vue&type=script&lang=js"
export * from "./ProductLifeCycle.vue?vue&type=script&lang=js"

import "./ProductLifeCycle.vue?vue&type=style&index=0&id=97901dfe&lang=scss&scoped=true"
import "./ProductLifeCycle.vue?vue&type=style&index=1&id=97901dfe&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97901dfe"]])

export default __exports__